import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '../layouts/AppLayout'
Vue.use(Router)
const orderTotal = () => import('../views/generator/orderTotal.vue')
const device = () => import('../views/generator/device.vue')
const lcd = () => import('../views/generator/lcd.vue')
const Login = () => import('../pages/login')
const order2 = () => import('../views/generator/order2.vue')
const order = () => import('../views/generator/order.vue')
const registerManager = () => import('../views/generator/registerManager')
const registerPyManager = () => import('../views/generator/registerPyManager')
const sysRole = () => import('../views/generator/sysRole')
const sysUserInfo = () => import('../views/generator/sysUserInfo')
const material = () => import('../views/generator/material')
const materialType = () => import('../views/generator/materialType')
const websocket = () => import('../views/generator/websocket')
const deviceRun = () => import('../views/generator/deviceRun')
const kb = () => import('../views/generator/kb')
const hxOrder = () => import('../views/generator/hxOrder')
const deviceRunDetial = () => import('../views/generator/deviceRunDetial')
const checkOrder = () => import('../views/generator/checkOrder')
const fileManage = () => import('../views/generator/fileManage')
const jgc = () => import('../views/pby/jgc.vue')
const deviceList = () => import('../views/pby/deviceList.vue')
const orderList = () => import('../views/pby/orderList.vue')
const appOrder = () => import('../views/app/appOrder.vue')
const appOrderTotal = () => import('../views/app/appOrderTotal.vue')
const appRegisterManager = () => import('../views/app/appRegisterManager.vue')
const msgInfo = () => import('../views/generator/msgInfo.vue')
const websocketTemp = () => import('../views/generator/websocketTemp.vue')
const file = () => import('../views/generator/file')
const log = () => import('../views/generator/log')
const orderPy = () => import('../views/generator/pyOrder.vue')
const router = new Router({
  mode: 'history',
  routes: [
    {
      name: '',
      path: '/',
      component: Login
    },
    {
      name: 'login',
      path: '/login',
      component: Login
    },
    {
      name: 'jgc',
      path: '/jgc',
      component: jgc
    },
    {
      name: 'deviceList',
      path: '/deviceList',
      component: deviceList
    },
    {
      name: 'orderList',
      path: '/orderList',
      component: orderList
    },
    {
      name: 'layout',
      path: '',
      component: AppLayout,
      children: [
        {
          name: 'file',
          path: '/file',
          meta: {
            title: '模型管理'
          },
          component: file
        },
        {
          name: 'order',
          path: '/order',
          meta: {
            title: '模型订单'
          },
          component: order
        }, {
          name: 'order2',
          path: '/order2',
          meta: {
            title: '订单日历'
          },
          component: order2
        }, {
          name: 'checkOrder',
          path: '/checkOrder',
          meta: {
            title: '审核订单'
          },
          component: checkOrder
        }, {
          name: 'kb',
          path: '/kb',
          meta: {
            title: '数据看板'
          },
          component: kb
        }, {
          name: 'hxOrder',
          path: '/hxOrder',
          meta: {
            title: '核销订单'
          },
          component: hxOrder
        }, {
          name: 'device',
          path: '/device',
          meta: {
            title: '设备管理'
          },
          component: device
        }, {
          name: 'lcd',
          path: '/lcd',
          meta: {
            title: 'lcd设备管理'
          },
          component: lcd
        }, {
          name: 'deviceRun',
          path: '/deviceRun',
          component: deviceRun,
          meta: {
            title: '设备运行统计'
          }
        }, {
          name: 'deviceRunDetial',
          path: '/deviceRunDetial',
          component: deviceRunDetial,
          meta: {
            title: '设备运行详情'
          }
        }, {
          name: 'registerManager',
          path: '/registerManager',
          meta: {
            title: '用户管理'
          },
          component: registerManager
        }, {
          name: 'registerPyManager',
          path: '/registerPyManager',
          meta: {
            title: '排牙用户'
          },
          component: registerPyManager
        }, {
          name: 'sysRole',
          path: '/sysRole',
          component: sysRole,
          meta: {
            title: '角色管理'
          }
        }, {
          name: 'sysUserInfo',
          path: '/sysUserInfo',
          component: sysUserInfo,
          meta: {
            title: '系统用户'
          }
        }, {
          name: 'material',
          path: '/material',
          component: material,
          meta: {
            title: '材料管理'
          }
        }, {
          name: 'materialType',
          path: '/materialType',
          component: materialType,
          meta: {
            title: '材料类型管理'
          }
        }, {
          name: 'orderTotal',
          path: '/orderTotal',
          component: orderTotal,
          meta: {
            title: '订单统计'
          }
        }, {
          name: 'websocket',
          path: '/websocket',
          component: websocket,
          meta: {
            title: '打印机实时数据'
          }
        }, {
          name: 'websocketTemp',
          path: '/websocketTemp',
          component: websocketTemp,
          meta: {
            title: '温湿度实时数据'
          }
        }, {
          name: 'fileManage',
          path: '/fileManage',
          component: fileManage,
          meta: {
            title: '文件管理'
          }
        }, {
          name: 'msgInfo',
          path: '/msgInfo',
          component: msgInfo,
          meta: {
            title: '消息通知设置'
          }
        }, {
          name: 'log',
          path: '/log',
          component: log,
          meta: {
            title: '日志管理'
          }
        }, {
          name: 'orderPy',
          path: '/orderPy',
          component: orderPy,
          meta: {
            title: '排牙订单'
          }
        }
      ]
    },
    {
      name: 'appOrder',
      path: '/appOrder',
      component: appOrder
    },
    {
      name: 'appOrderTotal',
      path: '/appOrderTotal',
      component: appOrderTotal
    },
    {
      name: 'appRegisterManager',
      path: '/appRegisterManager',
      component: appRegisterManager
    }
  ]
})
// 路由全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/') {
    next()
  } else {
    let sysuserToken = localStorage.getItem('token')
    if (sysuserToken == null || sysuserToken === '') {
      // alert('无权限，请登录')
      return next('/login')
    } else {
      if (to.path === '' || to.path === '/') {
        return next('/login')
      }
      return next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js